import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

const PaymentView = () => {
  const { pay_seq } = useParams();
  const [payment, setPayment] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (pay_seq) {
      const fetchPaymentData = async () => {
        try {
          const successHandler = (response) => {
            if (response.messageCode === 200) {
              setPayment(response.data);
              setLoading(false);
            } else {
              toast.error("결제 정보를 불러오는 중 오류가 발생했습니다.");
              setLoading(false);
            }
          };

          const errorHandler = (error) => {
            toast.error("결제 정보를 불러오는 중 오류가 발생했습니다.");
            setLoading(false);
          };

          await request.get(`/payments/list/admin/${pay_seq}`, {}, successHandler, errorHandler);
        } catch (error) {
          toast.error("결제 정보를 불러오는 중 오류가 발생했습니다.");
          setLoading(false);
        }
      };

      fetchPaymentData();
    }
  }, [pay_seq]);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <main>
      <h2 className="adm_com_pg_tit">결제완료</h2>
      <table className='adm_com_board_list type_row'>
        <colgroup>
          <col width="10%" /><col width="40%" />
          <col width="10%" /><col width="40%" />
        </colgroup>
        <tbody>
          <tr>
            <th>결제번호</th>
            <td colSpan={3}>{payment.pay_seq}</td>
          </tr>
          <tr>
            <th>주문번호</th>
            <td colSpan={3}>{payment.order_no}</td>
          </tr>
          <tr>
            <th>사용자 ID</th>
            <td colSpan={3}>{payment.user_seq_al_user?.user_id}</td>
          </tr>
          <tr>
            <th>결제 상태</th>
            <td colSpan={3}>{payment.pay_stat_comm_code?.code_nm_kr}</td>
          </tr>
          <tr>
            <th>상품</th>
            <td colSpan={3}>{payment.goods_ty_comm_code?.code_nm_kr}</td>
          </tr>
          <tr>
            <th>결제수단</th>
            <td colSpan={3}>{payment.pay_method_comm_code?.code_nm_kr}</td>
          </tr>
          <tr>
            <th>상품금액</th>
            <td colSpan={3}>{payment.goods_amt?.toLocaleString()} 원</td>
          </tr>
          <tr>
            <th>할인금액</th>
            <td colSpan={3}>{payment.dc_amt?.toLocaleString()} 원</td>
          </tr>
          <tr>
            <th>사용 포인트</th>
            <td colSpan={3}>{payment.used_points?.toLocaleString()} 점</td>
          </tr>
          <tr>
            <th>결제 대상금액</th>
            <td colSpan={3}>{payment.request_amt?.toLocaleString()} 원</td>
          </tr>
          <tr>
            <th>결제금액</th>
            <td colSpan={3}>{payment.pay_amt?.toLocaleString()} 원</td>
          </tr>
          <tr>
            <th>결제일</th>
            <td colSpan={3}>{new Date(payment.pay_dtm).toLocaleDateString()}</td>
          </tr>
          <tr>
            <th>등록일시</th>
            <td colSpan={3}>{new Date(payment.reg_dtm).toLocaleString()}</td>
          </tr>
          <tr>
            <th>구독 개월</th>
            <td colSpan={3}>{payment.subscription_months}</td>
          </tr>
          <tr>
            <th>빌링 키</th>
            <td colSpan={3}>{payment.billing_key}</td>
          </tr>
          <tr>
            <th>관리</th>
            <td colSpan={3}>{payment.alan_management}</td>
          </tr>
        </tbody>
      </table>
      <div className="adm_com_btn_wrap bottom center">
        {/* <button className="adm_com_btn blue">취소하기</button> */}
        <Link to="/Payment/History/All" className="adm_com_btn black">목록</Link>
      </div>
      <ToastContainer />
    </main>
  );
};

export default PaymentView;
